import { TextSpan } from "components/text-label";
import intl from "react-intl-universal";
import { CardFooterIndicator } from "./styled";

interface CardProps {
  totalVolume?: number;
  ordersCount: number;
}

export const FooterIndicator = (props: CardProps) => {
  const { totalVolume, ordersCount } = props;

  const style = { fontSize: "8px", fontWeight: 600, whiteSpace: "pre", lineHeight: "150%" };

  return (
    <CardFooterIndicator>
      {totalVolume ? (
        <>
          <TextSpan color={"var(--color-neutral-400)"} display="block" style={style}>
            {`${intl.get("commons.volumns").toUpperCase()}: `}
          </TextSpan>
          <TextSpan color={"var(--color-brand-300)"} display="block" style={style}>
            {totalVolume}
          </TextSpan>
          <TextSpan color={"var(--color-neutral-400)"} display="block" style={style}>
            {` + `}
          </TextSpan>
        </>
      ) : null}
      <TextSpan color={"var(--color-neutral-400)"} display="block" style={style}>
        {`${intl.get("commons.orders").toUpperCase()}: `}
      </TextSpan>
      <TextSpan color={"var(--color-feedback-warning-300)"} display="block" style={style}>
        {ordersCount}
      </TextSpan>
    </CardFooterIndicator>
  );
};
